import React from 'react';
import RefLink from '../shared/RefLink';
import CompanyList from './CompanyList';

/**
 * The companies of a Screening request / record — one row each: the name
 * (with "(now: …)" after a rename), its UEN underneath, and a link to the
 * engagement it is tied to on the right. Shared by both detail pages.
 */
export const ScreeningCompaniesList = ({ entities = [] }) => (
  <CompanyList
    entities={entities}
    controlOf={(e) => (e.engagementId ? (
      <RefLink to={`/qm/engagements/${e.engagementId}`} className="text-xs text-blue-600 hover:text-blue-800 underline">
        View Engagement
      </RefLink>
    ) : null)}
  />
);

